module.exports = __webpack_public_path__ + "static/media/boys-stick.b2700db8.png";